<geaui-page-header pageTitle="Refrigerant Properties" [hasBackArrow]="false" [withSidebar]="true">
  <div class="UnitsSelector">
    Units:
    <mat-radio-group [(ngModel)]="isUsUnits">
      <mat-radio-button [value]="true">US</mat-radio-button>
      <mat-radio-button [value]="false">SI</mat-radio-button>
    </mat-radio-group>
  </div>
</geaui-page-header>

<div *ngIf="!isLoaded" class="Content">
  <h3 class="Heading">Loading...</h3>
</div>
<div *ngIf="isLoaded" class="Content">
  <h3 class="Heading">Input </h3>
  <br>

</div>